import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Quake } from '../model/quake';
import { Region } from '../model/region';
import { EventsService } from '../service/events.service';

@Component({
  selector: 'app-animated-quakes',
  templateUrl: './animated-quakes.component.html',
  styleUrls: ['./animated-quakes.component.css']
})

export class AnimatedQuakesComponent implements OnInit {
  @Input() animateEvents: Quake[];
  @Input() region: Region;
  @Input() width: number;
  @Input() height: number;
  @ViewChild('animationCanvas', { static: true }) canvasAnimationRef2: ElementRef;

  angle = 0;
  fps = 30;
  fpsInterval = 1000 / this.fps;
  then = Date.now();
  startTime = this.then;
  animationFrame: number;
  animationCanvas: HTMLCanvasElement;
  animationCtx: CanvasRenderingContext2D;

  constructor(
    private eventsService: EventsService
  ) { }

  ngOnInit() {
    this.animationCanvas = this.canvasAnimationRef2.nativeElement;
    this.animationCtx = this.animationCanvas.getContext('2d');
    this.animateRecentEvents();
  }

  animateRecentEvents(): void {
    this.animationFrame = requestAnimationFrame(() => this.animateRecentEvents());

    const now = Date.now();
    const elapsed = now - this.then;

    // if enough time has elapsed, draw the next frame
    if (elapsed > this.fpsInterval && this.animateEvents.length) {

      // Get ready for next frame by setting then=now, but also adjust for your
      // specified fpsInterval not being a multiple of RAF's interval (16.7ms)
      this.then = now - (elapsed % this.fpsInterval);

      // Put your drawing code here

      this.animationCtx.clearRect(0, 0, this.animationCanvas.width, this.animationCanvas.height);

      // color in the background
      this.animationCtx.fillStyle = '#00000000';
      this.animationCtx.fillRect(0, 0, this.animationCanvas.width, this.animationCanvas.height);


      this.animateEvents.forEach((quake: Quake, index: number) => {
        this.animationCtx.lineWidth = this.eventsService.getMagStrikeWidth(quake) + 3;

        this.animationCtx.strokeStyle = this.eventsService.getColorFromAge(quake);

        const phase = index / this.animateEvents.length * Math.PI;
        const maxRadius = this.eventsService.getMagnitudePixels(quake);
        const radius = maxRadius * Math.abs(Math.cos(this.angle + phase));

        const transparency = Math.floor((radius / maxRadius) * 170).toString(16).padStart(2, '0')

        this.animationCtx.fillStyle = this.animationCtx.strokeStyle + transparency;

        const xy = this.region.latLng2Pixel(quake);
        if (xy === null) { return; }
        this.animationCtx.beginPath();
        this.animationCtx.arc(xy.x, xy.y, radius, 0, Math.PI * 2, false);
        this.animationCtx.closePath();
        if (radius > maxRadius * 0.90) {
          // do something exciting;
        }
        this.animationCtx.stroke();
        this.animationCtx.fill();
      });

      this.angle += Math.PI / 64;
      this.angle %= Math.PI;
    }
  }
}
